import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"

export type UserLibraryViewMode = "grid" | "list"

export interface UserConfigurationsStore {
  viewMode: UserLibraryViewMode
  setViewMode: (viewMode: UserLibraryViewMode) => void
}

const INITIAL_USER_CONFIGURATIONS_STORE: Omit<
  UserConfigurationsStore,
  "setViewMode"
> = {
  viewMode: "grid",
}

export const useUserConfigurationsStore = create<UserConfigurationsStore>()(
  devtools(
    persist(
      set => ({
        viewMode: INITIAL_USER_CONFIGURATIONS_STORE.viewMode,
        setViewMode: (viewMode: UserLibraryViewMode) => set({ viewMode }),
      }),
      {
        name: "user-configurations-store",
      }
    ),
    {
      name: "UserConfigurationsStore",
      enabled: process.env.NODE_ENV === "development",
    }
  )
)
